<div class="modal-body">
    <form class="add-external-map-form">
        <span>Enter the Url for the Map Service or ArcGIS Webmap below. <span class="font-size--3">(Ensure ArcGIS Webmap is shared with 'Everyone.')</span></span><br />

        <div class="map-url-input">
            <label for="mapUrl" class="map-url-label">URL:</label>
            <input id="mapUrl" type="text" name="mapUrlInput" [disabled]="loading" [(ngModel)]="agolMapUrl"
                   placeholder="Enter your AGOL Web Map URL Here" required />
        </div>

        <div *ngIf="loading" class="loader is-active padding-leader-3 padding-trailer-3">
            <div class="loader-bars"></div>
        </div>

        <fieldset *ngIf="layers.length" class="fieldset-checkbox">
            <label><input type="checkbox" [checked]="selectedLayers.length === layers.length" (change)="toggleAllLayers()"><strong>All</strong></label>
            <label *ngFor="let layer of layers; trackBy: id" [title]="layer.description"><input type="checkbox" [checked]="layer.selected" (change)="layer.selected = !layer.selected"> {{ layer.name }}</label>
        </fieldset>

        <div *ngIf="webMapId" class="map-url-input">
            <label class="map-url-label">Web Map ID: </label>
            <span>{{ webMapId }}&nbsp;</span>
            <span>(<a [href]="mapJsonUrl" target="_blank">Web JSON Source URL</a>)</span>
        </div>

        <div *ngIf="errorMessage" class="alert is-active alert-red" style="margin: 0 auto 15px;">
            {{ errorMessage }}
            <button class="alert-close icon-ui-close" (click)="errorMessage = ''"></button>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button class="btn btn-red" (click)="close()" style="float: right;">Cancel</button>
    <button class="btn" (click)="addToMap()" [disabled]="!selectedLayers.length" style="float: right; margin-right: 10px;">Add To Map</button>
</div>
